// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/homepage-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/homepage.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

html,
body,
#root {
  width: 100%;
  min-height: 100vh;
  max-width: 100vw;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
}

#root {
  display: flex;
  flex-direction: column;
  align-items: center;
}

body {
  background: white;
}

.navbar {
  height: 12vh;
  width: 100vw;
  max-width: 100vw;
  display: flex;
  align-items: center;
  padding-left: 5vw;
  justify-content: space-between;
  box-sizing: border-box;
}

.navbar img {
  height: 4vh;
  cursor: pointer;
}

.navbar h2 span {
  color: #6616cd;
}

.page {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  height: 80vh;
  width: 100vw;
  /* Smooth gradient background */
  color: black;
  text-align: center;
  font-family: "Syne", sans-serif;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

/* Content Section Styling */
.homeContent {
  position: relative;
  padding-top: 15vh;
  padding-left: 5vw;
  display: flex;
  flex-direction: column;
  align-items: start;
  text-align: start;
  max-width: 960px;
  /* Optimal width for reading */
  width: 50%;
  height: 80vh;
}

.handSign {
  position: absolute;
  left: 62vw;
  top: 10vh;
  height: 25vw;
  width: 25vw;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

/* Typography Improvements */
.homeContent h1 {
  font-size: 2.7rem;
  /* Larger for impact */

  line-height: 1.2;
}

.homeContent p {
  font-size: 1.4rem;
  /* Larger text for easier reading */
  color: black;
  /* Slightly lighter shade for soft contrast */
  max-width: 600px;
  /* Optimal line length */
  margin-bottom: 2em;
}

/* Buttons for a More Interactive Feel */

.Container {
  width: 50vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80vh;
  border: 1px solid black;
  margin: 20px;
  background-color: #f9f9f9;
}

.Container input {
  width: 80%;
  margin-bottom: 20px;
  padding: 20px;
}

.Container button {
  background: rgb(0, 119, 255);
  border: none;
  border-radius: 9px;
  padding: 9px;
  color: white;
}

.interestInput {
  width: 80%;
  margin-bottom: 20px;
  height: 25vh;
  resize: vertical;
  padding: 20px;
}

.BoxPage {
  height: 80vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  background: white;
}

.BoxpageContent {
  height: 80vh;
  width: 100vw;
  display: flex;
  justify-content: center;
}

.ConnectionDetails {
  margin: 20px;
  height: 80vh;
  width: 65vw;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

button:disabled {
  background: rgb(142, 173, 208);
}

.videoPlayer {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Chat Screen Overall Styling */
.ChatScreen {
  margin: 20px;
  height: 80vh;
  width: 35vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px;
  background: #ffffff;
  /* Light background to ensure readability */
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* Subtle shadow for depth */
  border: 1px solid rgba(0, 0, 0, 0.1);
  /* Light border for subtle separation */
}

/* Where the messages are displayed */
.Messages {
  flex-grow: 1;
  overflow-y: auto;
  /* Ensures smooth scrolling */
  background: #f9f9f9;
  /* Slightly off-white for low contrast */
  border-radius: 10px;
  padding: 10px;
  /* Padding inside the messages box */
  margin-bottom: 10px;
  /* Space before the input area */
}

/* Styling messages */

/*.rightAttached {
  margin: 5px;
  background-color: #962fbf;
  color: white;
  padding: 10px;
  border-radius: 10px 10px 0px 10px;
}
.leftAttached {
  margin: 5px;
  width: fit-content;
  padding: 10px;
  color: white;
  background-color: #4f5bd5;
  border-radius: 10px 10px 10px 0px;
}*/
.button-starter {
  background: linear-gradient(to right, #4f5bd5, #962fbf);
  width: 100%;
  /* Gradient from bluish to purple */
  color: white;
  /* Text color */
  /* Font weight */
  padding: 8px 16px;
  /* Padding around text */
  border: none;
  /* No borders */
  border-radius: 5px;
  /* Rounded corners */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  /* Subtle shadow */
  cursor: pointer;
  /* Cursor indicates button */
  transition: all 0.3s ease;
  /* Smooth transition for hover effects */
  margin: 5px;
}

.button-starter:hover {
  background: linear-gradient(to right,
      #962fbf,
      #4f5bd5);
  /* Invert gradient on hover */
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.3);
  /* Larger shadow on hover */
}

/* Input area styling */
.BottomInput {
  display: flex;
  align-items: center;
  /* Aligns items vertically */
}

.BottomInput input {
  flex: 1 1;
  padding: 12px;
  border-radius: 20px;
  /* Rounded borders for the input */
  border: 1px solid #ccc;
  /* Subtle border for input */
  margin-right: 10px;
  /* Space between input and button */
}

.BottomInput button {
  background: rgb(0, 119, 255);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  /* Rounded borders for buttons */
  cursor: pointer;
  transition: background-color 0.3s;
  /* Smooth transition for hover effect */
}

.BottomInput button:hover {
  background: rgb(0, 95, 204);
  /* Darker shade on hover */
}

.BottomInput button:disabled {
  background: rgb(142, 173, 208);
  cursor: not-allowed;
}

.ChatBox {
  width: 100%;
  display: flex;
  justify-content: end;
  border-radius: 10px;
}

.videoContainer {
  display: flex;
}

.buttonNormal {
  font-family: "Syne", sans-serif;
  font-size: 2.5vh;
  padding: 0.7rem 4rem;
  border: none;
  border-radius: 0.5rem;
  background-color: #6616cd;
  color: #ffffff;
  cursor: pointer;
}

.buttonNormal:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.light-font {
  font-weight: lighter;
}

/*   Avatar Css */

@keyframes scaleUpDown {

  0%,
  100% {
    height: 20%;
  }

  50% {
    height: 100%;
  }
}

@keyframes rotateGear {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes rotateGearReverse {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(-360deg);
  }
}

/*media queries*/
@media (max-width: 768px) {
  body {
    overflow-x: hidden;
  }

  .navbar {
    height: 10vh;
  }

  .BoxPage {
    height: -moz-fit-content;
    height: fit-content;
    /* Double the height */
    /* Remove column direction */
  }

  .BoxpageContent {
    height: -moz-fit-content;
    height: fit-content;

    flex-direction: column;
  }

  .ChatScreen {
    height: 40vh;
    width: 90vw;
    border: 2px solid gainsboro;
    border-radius: 30px;
  }

  .ConnectionDetails {
    width: 100vw;
    margin: 0;
    height: -moz-fit-content;
    height: fit-content;
    max-height: 50vh;
  }

  .videoPlayer {
    flex-direction: row;
  }

  .videoContainer {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .videoContainer video {
    width: 90%;
    margin-bottom: 5px;
  }

  .imageCard {
    display: none;
  }

  .avatarCard {
    width: 100vw;
  }

  .nav-right {
    display: none;
  }

  .handSign {
    position: static;
    align-self: center;
    height: 25vh;
    width: 25vh;
  }

  .page {
    background: none;
  }

  .homeContent {
    width: 100%;
    padding: 20px;
    align-items: start;
    justify-content: space-evenly;
  }

  .homeContent h1 {
    font-size: 2.2rem;
    /* Larger for impact */
  }

  .homeContent p {
    font-size: 1.2rem;
    /* Larger text for easier reading */
    color: black;
    /* Slightly lighter shade for soft contrast */
    max-width: 600px;
    /* Optimal line length */
    margin-bottom: 2em;
  }
}

/* Add these styles for tablet responsiveness */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .BoxPage {
    min-height: 100vh;
    padding: 1rem;
  }

  .BoxpageContent {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    height: auto;
  }

  .ConnectionDetails {
    width: 100%;
    margin: 0;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
  }

  .ChatScreen {
    margin-top: 1rem;
    height: 40vh;
    width: 90vw;
    border: 2px solid gainsboro;
    border-radius: 30px;
  }

  /* Adjust navbar for tablets */
  .navbar {
    padding: 0 2rem;
    height: 10vh;
  }
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-right: 2vw;
}

.profile-nav-button {
  font-family: "Syne", sans-serif;
  font-size: 1rem;
  padding: 0.3rem 1.2rem;
  border-radius: 12px;
  border: 2px solid #6616cd;
  background-color: white;
  color: #6616cd;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-right: -1.2vw;
}

.profile-nav-button:hover {
  background-color: #6616cd;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 22, 205, 0.2);
}

.profile-nav-button svg {
  width: 18px;
  height: 18px;
  fill: currentColor;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,mDAAyC;EACzC,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,WAAW;EACX,mDAAsC;EACtC,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,sBAAsB;;EAEtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,YAAY;EACZ,6CAA6C;EAC7C,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,wCAAwC;;AAExC;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;;EAEX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,gCAAgC;AAChC;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,yCAAyC;EACzC,4BAA4B;EAC5B,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA,qCAAqC;AACrC;EACE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,qBAAqB;;AAErB;;;;;;;;;;;;;;EAcE;AACF;EACE,uDAAuD;EACvD,WAAW;EACX,mCAAmC;EACnC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE;;cAEY;EACZ,6BAA6B;EAC7B,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,iBAAiB;;AAEjB;;EAEE;;IAEE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,gBAAgB;AAChB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,wBAAmB;IAAnB,mBAAmB;IACnB,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,wBAAmB;IAAnB,mBAAmB;;IAEnB,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,SAAS;IACT,wBAAmB;IAAnB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,mCAAmC;IACnC,YAAY;IACZ,6CAA6C;IAC7C,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;EACpB;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,WAAW;IACX,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA,8BAA8B;EAC9B;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody,\n#root {\n  width: 100%;\n  min-height: 100vh;\n  max-width: 100vw;\n  overflow-x: hidden;\n  margin: 0;\n  padding: 0;\n}\n\n#root {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\nbody {\n  background: white;\n}\n\n.navbar {\n  height: 12vh;\n  width: 100vw;\n  max-width: 100vw;\n  display: flex;\n  align-items: center;\n  padding-left: 5vw;\n  justify-content: space-between;\n  box-sizing: border-box;\n}\n\n.navbar img {\n  height: 4vh;\n  cursor: pointer;\n}\n\n.navbar h2 span {\n  color: #6616cd;\n}\n\n.page {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: start;\n  height: 80vh;\n  width: 100vw;\n  /* Smooth gradient background */\n  color: black;\n  text-align: center;\n  font-family: \"Syne\", sans-serif;\n  background: url(\"assets/homepage-bg.png\");\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n}\n\n/* Content Section Styling */\n.homeContent {\n  position: relative;\n  padding-top: 15vh;\n  padding-left: 5vw;\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  text-align: start;\n  max-width: 960px;\n  /* Optimal width for reading */\n  width: 50%;\n  height: 80vh;\n}\n\n.handSign {\n  position: absolute;\n  left: 62vw;\n  top: 10vh;\n  height: 25vw;\n  width: 25vw;\n  background: url(\"assets/homepage.gif\");\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n}\n\n/* Typography Improvements */\n.homeContent h1 {\n  font-size: 2.7rem;\n  /* Larger for impact */\n\n  line-height: 1.2;\n}\n\n.homeContent p {\n  font-size: 1.4rem;\n  /* Larger text for easier reading */\n  color: black;\n  /* Slightly lighter shade for soft contrast */\n  max-width: 600px;\n  /* Optimal line length */\n  margin-bottom: 2em;\n}\n\n/* Buttons for a More Interactive Feel */\n\n.Container {\n  width: 50vw;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 80vh;\n  border: 1px solid black;\n  margin: 20px;\n  background-color: #f9f9f9;\n}\n\n.Container input {\n  width: 80%;\n  margin-bottom: 20px;\n  padding: 20px;\n}\n\n.Container button {\n  background: rgb(0, 119, 255);\n  border: none;\n  border-radius: 9px;\n  padding: 9px;\n  color: white;\n}\n\n.interestInput {\n  width: 80%;\n  margin-bottom: 20px;\n  height: 25vh;\n  resize: vertical;\n  padding: 20px;\n}\n\n.BoxPage {\n  height: 80vh;\n  width: 100vw;\n  display: flex;\n  flex-direction: column;\n  background: white;\n}\n\n.BoxpageContent {\n  height: 80vh;\n  width: 100vw;\n  display: flex;\n  justify-content: center;\n}\n\n.ConnectionDetails {\n  margin: 20px;\n  height: 80vh;\n  width: 65vw;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\nbutton:disabled {\n  background: rgb(142, 173, 208);\n}\n\n.videoPlayer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Chat Screen Overall Styling */\n.ChatScreen {\n  margin: 20px;\n  height: 80vh;\n  width: 35vw;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 15px;\n  background: #ffffff;\n  /* Light background to ensure readability */\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  /* Subtle shadow for depth */\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  /* Light border for subtle separation */\n}\n\n/* Where the messages are displayed */\n.Messages {\n  flex-grow: 1;\n  overflow-y: auto;\n  /* Ensures smooth scrolling */\n  background: #f9f9f9;\n  /* Slightly off-white for low contrast */\n  border-radius: 10px;\n  padding: 10px;\n  /* Padding inside the messages box */\n  margin-bottom: 10px;\n  /* Space before the input area */\n}\n\n/* Styling messages */\n\n/*.rightAttached {\n  margin: 5px;\n  background-color: #962fbf;\n  color: white;\n  padding: 10px;\n  border-radius: 10px 10px 0px 10px;\n}\n.leftAttached {\n  margin: 5px;\n  width: fit-content;\n  padding: 10px;\n  color: white;\n  background-color: #4f5bd5;\n  border-radius: 10px 10px 10px 0px;\n}*/\n.button-starter {\n  background: linear-gradient(to right, #4f5bd5, #962fbf);\n  width: 100%;\n  /* Gradient from bluish to purple */\n  color: white;\n  /* Text color */\n  /* Font weight */\n  padding: 8px 16px;\n  /* Padding around text */\n  border: none;\n  /* No borders */\n  border-radius: 5px;\n  /* Rounded corners */\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n  /* Subtle shadow */\n  cursor: pointer;\n  /* Cursor indicates button */\n  transition: all 0.3s ease;\n  /* Smooth transition for hover effects */\n  margin: 5px;\n}\n\n.button-starter:hover {\n  background: linear-gradient(to right,\n      #962fbf,\n      #4f5bd5);\n  /* Invert gradient on hover */\n  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.3);\n  /* Larger shadow on hover */\n}\n\n/* Input area styling */\n.BottomInput {\n  display: flex;\n  align-items: center;\n  /* Aligns items vertically */\n}\n\n.BottomInput input {\n  flex: 1;\n  padding: 12px;\n  border-radius: 20px;\n  /* Rounded borders for the input */\n  border: 1px solid #ccc;\n  /* Subtle border for input */\n  margin-right: 10px;\n  /* Space between input and button */\n}\n\n.BottomInput button {\n  background: rgb(0, 119, 255);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 10px;\n  /* Rounded borders for buttons */\n  cursor: pointer;\n  transition: background-color 0.3s;\n  /* Smooth transition for hover effect */\n}\n\n.BottomInput button:hover {\n  background: rgb(0, 95, 204);\n  /* Darker shade on hover */\n}\n\n.BottomInput button:disabled {\n  background: rgb(142, 173, 208);\n  cursor: not-allowed;\n}\n\n.ChatBox {\n  width: 100%;\n  display: flex;\n  justify-content: end;\n  border-radius: 10px;\n}\n\n.videoContainer {\n  display: flex;\n}\n\n.buttonNormal {\n  font-family: \"Syne\", sans-serif;\n  font-size: 2.5vh;\n  padding: 0.7rem 4rem;\n  border: none;\n  border-radius: 0.5rem;\n  background-color: #6616cd;\n  color: #ffffff;\n  cursor: pointer;\n}\n\n.buttonNormal:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.light-font {\n  font-weight: lighter;\n}\n\n/*   Avatar Css */\n\n@keyframes scaleUpDown {\n\n  0%,\n  100% {\n    height: 20%;\n  }\n\n  50% {\n    height: 100%;\n  }\n}\n\n@keyframes rotateGear {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes rotateGearReverse {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(-360deg);\n  }\n}\n\n/*media queries*/\n@media (max-width: 768px) {\n  body {\n    overflow-x: hidden;\n  }\n\n  .navbar {\n    height: 10vh;\n  }\n\n  .BoxPage {\n    height: fit-content;\n    /* Double the height */\n    /* Remove column direction */\n  }\n\n  .BoxpageContent {\n    height: fit-content;\n\n    flex-direction: column;\n  }\n\n  .ChatScreen {\n    height: 40vh;\n    width: 90vw;\n    border: 2px solid gainsboro;\n    border-radius: 30px;\n  }\n\n  .ConnectionDetails {\n    width: 100vw;\n    margin: 0;\n    height: fit-content;\n    max-height: 50vh;\n  }\n\n  .videoPlayer {\n    flex-direction: row;\n  }\n\n  .videoContainer {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .videoContainer video {\n    width: 90%;\n    margin-bottom: 5px;\n  }\n\n  .imageCard {\n    display: none;\n  }\n\n  .avatarCard {\n    width: 100vw;\n  }\n\n  .nav-right {\n    display: none;\n  }\n\n  .handSign {\n    position: static;\n    align-self: center;\n    height: 25vh;\n    width: 25vh;\n  }\n\n  .page {\n    background: none;\n  }\n\n  .homeContent {\n    width: 100%;\n    padding: 20px;\n    align-items: start;\n    justify-content: space-evenly;\n  }\n\n  .homeContent h1 {\n    font-size: 2.2rem;\n    /* Larger for impact */\n  }\n\n  .homeContent p {\n    font-size: 1.2rem;\n    /* Larger text for easier reading */\n    color: black;\n    /* Slightly lighter shade for soft contrast */\n    max-width: 600px;\n    /* Optimal line length */\n    margin-bottom: 2em;\n  }\n}\n\n/* Add these styles for tablet responsiveness */\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .BoxPage {\n    min-height: 100vh;\n    padding: 1rem;\n  }\n\n  .BoxpageContent {\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n    height: auto;\n  }\n\n  .ConnectionDetails {\n    width: 100%;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    /* align-items: center; */\n  }\n\n  .ChatScreen {\n    margin-top: 1rem;\n    height: 40vh;\n    width: 90vw;\n    border: 2px solid gainsboro;\n    border-radius: 30px;\n  }\n\n  /* Adjust navbar for tablets */\n  .navbar {\n    padding: 0 2rem;\n    height: 10vh;\n  }\n}\n\n.nav-links {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  margin-right: 2vw;\n}\n\n.profile-nav-button {\n  font-family: \"Syne\", sans-serif;\n  font-size: 1rem;\n  padding: 0.3rem 1.2rem;\n  border-radius: 12px;\n  border: 2px solid #6616cd;\n  background-color: white;\n  color: #6616cd;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin-right: -1.2vw;\n}\n\n.profile-nav-button:hover {\n  background-color: #6616cd;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 22, 205, 0.2);\n}\n\n.profile-nav-button svg {\n  width: 18px;\n  height: 18px;\n  fill: currentColor;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
